import type { TocModuleData } from '../TocPage'

// Case 1: 2-mod basic (chapter 5+6, lesson 5+6)
export const case1Basic: TocModuleData[] = [
  {
    chapterNumber: 5,
    moduleName: '분수와 소수',
    colorIndex: 0,
    lessons: [
      { lessonName: '3/4을 소수로, 십커플을 이용하라', startPage: 6, grade: '초 5-1', unitInfo: '4단원. 약분과 통분' },
      { lessonName: '수의 표현, 대표 체급과 개수로', startPage: 12, grade: '중 1-1', unitInfo: '1단원. 소인수분해' },
      { lessonName: '소수점 대칭네모', startPage: 18, grade: '중 1-1', unitInfo: '1단원. 소인수분해' },
      { lessonName: '작은 수의 표현도 대표 체급과 개수로', startPage: 24, grade: '고 2-1', unitInfo: '1단원. 지수함수와 로그함수' },
      { lessonName: '곱할 때 체급 수는 더해라', startPage: 30, grade: '고 2-1', unitInfo: '1단원. 지수함수와 로그함수' },
    ],
  },
  {
    chapterNumber: 6,
    moduleName: '소수의 활용',
    colorIndex: 1,
    lessons: [
      { lessonName: '무서운 0의 파워 4가지', startPage: 36, grade: '고 2-1', unitInfo: '1단원. 지수함수와 로그함수' },
      { lessonName: '소수의 뺄셈', startPage: 42, grade: '초 4-2', unitInfo: '3단원. 소수의 덧셈과 뺄셈' },
      { lessonName: '마이크로와 나노, 정말 작네', startPage: 48, grade: '고 2-1', unitInfo: '1단원. 지수함수와 로그함수' },
      { lessonName: '바이트, 미디어 크기의 단위', startPage: 54, grade: '고 2-1', unitInfo: '1단원. 지수함수와 로그함수' },
      { lessonName: '나누려니 너무 작네, 확대경을 이용하라', startPage: 60, grade: '초 6-1', unitInfo: '3단원. 소수의 나눗셈' },
      { lessonName: '반, 반의반, 반의반의 반, 감으로 분수 계산', startPage: 66, grade: '초 6-1', unitInfo: '1단원. 분수의 나눗셈' },
    ],
  },
]

// Case 2: 2-mod max (chapter 12+13, lesson 9+10) — boundary case
export const case2Max: TocModuleData[] = [
  {
    chapterNumber: 12,
    moduleName: '최대공약수와 최소공배수',
    colorIndex: 0,
    lessons: [
      { lessonName: '2차원 케이크 자르기, 공배수', startPage: 6, grade: '초 5-1', unitInfo: '2단원. 약수와 배수' },
      { lessonName: '3차원 케이크 자르기, 공약수', startPage: 12, grade: '초 5-1', unitInfo: '2단원. 약수와 배수' },
      { lessonName: '최대공약수, 최소공배수 그리고 DNA', startPage: 18, grade: '초 5-1', unitInfo: '2단원. 약수와 배수' },
      { lessonName: '서로소, 공통 DNA가 없네', startPage: 24, grade: '중 1-1', unitInfo: '1단원. 소인수분해' },
      { lessonName: '세 수의 최대공약수와 최소공배수', startPage: 30, grade: '중 1-1', unitInfo: '1단원. 소인수분해' },
      { lessonName: '분수 표현, 간단하게 기약분수로', startPage: 36, grade: '초 5-1', unitInfo: '4단원. 약분과 통분' },
      { lessonName: '나머지로 최대공약수 빨리 찾기', startPage: 42, grade: '중 1-1', unitInfo: '1단원. 소인수분해' },
      { lessonName: '번곱으로 최소공배수 빨리 찾기', startPage: 48, grade: '중 1-1', unitInfo: '1단원. 소인수분해' },
      { lessonName: '두 자연수를 보고 생각나는 것들', startPage: 54, grade: '중 1-1', unitInfo: '1단원. 소인수분해' },
    ],
  },
  {
    chapterNumber: 13,
    moduleName: '분수의 덧셈과 뺄셈',
    colorIndex: 1,
    lessons: [
      { lessonName: '분수의 크기 비교, 분자가 같아도 쉽네', startPage: 60, grade: '초 5-1', unitInfo: '4단원. 약분과 통분' },
      { lessonName: '분수 비교, 매개체를 이용하라', startPage: 66, grade: '초 5-1', unitInfo: '4단원. 약분과 통분' },
      { lessonName: '분수를 더하라? 단위를 맞춰라!', startPage: 72, grade: '초 5-1', unitInfo: '5단원. 분수의 덧셈과 뺄셈' },
      { lessonName: '분수 더하기, 공통틀을 만들어라', startPage: 78, grade: '초 5-1', unitInfo: '5단원. 분수의 덧셈과 뺄셈' },
      { lessonName: '통분없이 의미로 즉시 대답하기', startPage: 84, grade: '초 5-1', unitInfo: '5단원. 분수의 덧셈과 뺄셈' },
      { lessonName: '더 간단한 두 분수 차이로', startPage: 90, grade: '고 1-2', unitInfo: '3단원. 함수와 그래프' },
      { lessonName: '대분수와 가분수의 덧셈과 뺄셈', startPage: 96, grade: '중 1-1', unitInfo: '2단원. 정수와 유리수' },
      { lessonName: '분수 비교, 핵심은 감 잡기', startPage: 102, grade: '초 5-1', unitInfo: '4단원. 약분과 통분' },
      { lessonName: '분수 비교, 분자 분모에 2씩 더하면?', startPage: 108, grade: '중 1-1', unitInfo: '2단원. 정수와 유리수' },
      { lessonName: '위 아래의 차이가 같은 두 분수의 뺄셈', startPage: 114, grade: '중 1-1', unitInfo: '2단원. 정수와 유리수' },
    ],
  },
]

// Case 3: 3-mod (chapter 7+8+9, lesson 8+7+3) — three-modules layout
export const case3ThreeMod: TocModuleData[] = [
  {
    chapterNumber: 7,
    moduleName: '모양은 각이야',
    colorIndex: 0,
    lessons: [
      { lessonName: '차원을 결정하는 점의 개수', startPage: 6, grade: '고 3-2', unitInfo: '1단원. 공간도형과 공간좌표' },
      { lessonName: '삼각형, 숨겨진 진실을 찾아라', startPage: 12, grade: '중 1-2', unitInfo: '1단원. 기본도형과 작도' },
      { lessonName: '369직각삼각형, 정삼각형을 접어라', startPage: 18, grade: '초 4-2', unitInfo: '2단원. 삼각형' },
      { lessonName: '주요 각들', startPage: 24, grade: '초 4-1', unitInfo: '2단원. 각도' },
      { lessonName: '닮았다? 확대하면 겹친다', startPage: 30, grade: '중 2-2', unitInfo: '2단원. 도형의 닮음과 피타고라스 정리' },
      { lessonName: '닮았다? 각이 같다', startPage: 36, grade: '중 2-2', unitInfo: '2단원. 도형의 닮음과 피타고라스 정리' },
      { lessonName: '만나면 같은 맞꼭지각, 평행이면 같은 동위각과 엇각', startPage: 42, grade: '중 1-2', unitInfo: '1단원. 기본도형과 작도' },
      { lessonName: '삼각형 변과 각의 관계', startPage: 48, grade: '중 1-2', unitInfo: '1단원. 기본도형과 작도' },
    ],
  },
  {
    chapterNumber: 8,
    moduleName: '분수의 덧셈과 뺄셈',
    colorIndex: 1,
    lessons: [
      { lessonName: '분수의 크기 비교, 분자가 같아도 쉽네', startPage: 54, grade: '중 1-2', unitInfo: '1단원. 기본도형과 작도' },
      { lessonName: '분수 비교, 매개체를 이용하라', startPage: 60, grade: '중 1-2', unitInfo: '1단원. 기본도형과 작도' },
      { lessonName: '분수 비교, 매개체를 이용하라', startPage: 66, grade: '중 1-2', unitInfo: '1단원. 기본도형과 작도' },
      { lessonName: '분수를 더하라? 단위를 맞춰라!', startPage: 72, grade: '중 1-2', unitInfo: '1단원. 기본도형과 작도' },
      { lessonName: '분수 더하기, 공통틀을 만들어라', startPage: 78, grade: '중 2-2', unitInfo: '1단원. 도형의 성질' },
      { lessonName: '통분없이 의미로 즉시 대답하기', startPage: 84, grade: '중 2-2', unitInfo: '2단원. 도형의 닮음과 피타고라스 정리' },
      { lessonName: '더 간단한 두 분수 차이로', startPage: 90, grade: '중 2-2', unitInfo: '2단원. 도형의 닮음과 피타고라스 정리' },
    ],
  },
  {
    chapterNumber: 9,
    moduleName: '삼각형의 넓이',
    colorIndex: 2,
    lessons: [
      { lessonName: '분수의 크기 비교, 분자가 같아도 쉽네', startPage: 96, grade: '초 5-1', unitInfo: '6단원. 다각형의 둘레와 넓이' },
      { lessonName: '분수 비교, 매개체를 이용하라', startPage: 102, grade: '중 1-2', unitInfo: '1단원. 기본도형과 작도' },
      { lessonName: '분수를 더하라? 단위를 맞춰라!', startPage: 108, grade: '중 1-1', unitInfo: '3단원. 방정식' },
    ],
  },
]

// Case 4: 2-mod overflow (mod1 12 lesson — exceeds page1, lessons split to page2)
export const case4Overflow: TocModuleData[] = [
  {
    chapterNumber: 5,
    moduleName: '분수와 소수',
    colorIndex: 0,
    lessons: Array.from({ length: 12 }, (_, i) => ({
      lessonName: `분수와 소수 lesson ${i + 1}`,
      startPage: 6 + i * 6,
      grade: '초 5-1',
      unitInfo: '4단원. 약분과 통분',
    })),
  },
  {
    chapterNumber: 6,
    moduleName: '소수의 활용',
    colorIndex: 1,
    lessons: Array.from({ length: 5 }, (_, i) => ({
      lessonName: `소수의 활용 lesson ${i + 1}`,
      startPage: 78 + i * 6,
      grade: '초 6-1',
      unitInfo: '1단원. 분수의 나눗셈',
    })),
  },
]

export const TOC_CASES = {
  case1Basic,
  case2Max,
  case3ThreeMod,
  case4Overflow,
} as const

export type TocCaseKey = keyof typeof TOC_CASES
